export default "__VITE_ASSET__DuSC9Ie0__"